import { createSelector } from "reselect";
import { toSelectOptions } from "../../../adapters/converters/toSelectOption";
import { dynamicSort } from "../../../adapters/sort";
import Country from "../../../domains/Country";
import { RootState } from "../../index";

export const countriesSelector = (state: RootState) => {
  return state.countries.countries;
};

export const areCountriesLoadingSelector = (state: RootState) => {
  return state.countries.areCountriesLoading;
};

export const hasErrorLoadingCountriesSelector = (state: RootState) => {
  return state.countries.hasErrorLoadingCountries;
};

export const countriesSelectOptionsSelector = createSelector(
  countriesSelector,
  (countries: Country[]) => {
    return toSelectOptions(countries).sort(dynamicSort("title"));
  },
);
